/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React from 'react';
import PropTypes from 'prop-types';

import {
  ClickAwayListener, Paper, FormControl, Grid, Button, Typography,
} from '@material-ui/core';
import useStyles from './styles';

const ModalWarning = ({ title, content, onClose }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <ClickAwayListener onClickAway={onClose}>
        <Paper classes={{ root: classes.panel }}>
          <h1 className={classes.title}>{title}</h1>
          <Typography className={classes.content}>{content}</Typography>
          <FormControl fullWidth component="fieldset" className={classes.formControl}>
            <Grid container direction="row" justify="flex-end" alignItems="center">
              <Button className={classes.button} onClick={onClose}>OK</Button>
            </Grid>
          </FormControl>
        </Paper>
      </ClickAwayListener>
    </div>
  );
};

ModalWarning.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModalWarning;
